<template>
  <component
    :is="tag"
    v-bind="$attrs"
    ref="label"
    :class="{ 'label': tag == 'label' }"
    :contenteditable="editable"
    @input="update()">
  </component>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    editable: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'label'
    }
  },
  data() {
    return {
      oDoc: null
    }
  },
  mounted() {
    this.initDoc();
  },
  methods: {
    initDoc() {
      this.oDoc = this.$refs["label"];
      if (this.text) {
        this.oDoc.innerHTML = this.text;
      }
    },
    update() {
      let oContent = document.createRange();
      oContent.selectNodeContents(this.oDoc);
      const contentStr = oContent.toString().trim();
      this.$emit("update:text", contentStr);
      this.$emit("update", contentStr);
    }
  }
}
</script>

<style lang="scss" scoped>
.label[contenteditable="true"]{
  &:hover {
    background: gainsboro;
    border-radius: 4px;
    border: 1px solid darkgray;
  }
  &:focus {
    outline: none;
    border-radius: 4px;
    background: gainsboro;
    border: 1px solid darkgray;
    padding: calc(0.5em - 1px) calc(0.75em - 1px);
  }
}
</style>
